import axios from 'axios';

export const getFieldPresets = async () => {
    try {
        const { data } = await axios.get('/api/fields/presets');
        return data;
    } catch (err) {
        const status = err?.response?.status;
        if (status === 404) {
            throw new Error(
                'Field presets endpoint not found (404). This usually means the backend service has not been redeployed/restarted with the latest code. Redeploy the backend and try again.'
            );
        }
        throw err;
    }
};

export const getSyntheticCancelSettings = async () => {
    const { data } = await axios.get('/api/synthetic-cancel/settings');
    return data;
};

export const saveSyntheticCancelSettings = async (settings = {}) => {
    const { data } = await axios.post('/api/synthetic-cancel/settings', settings);
    return data;
};

export const getApiPresenceSettings = async () => {
    const { data } = await axios.get('/api/synthetic-cancel/api-presence/settings');
    return data;
};

export const saveApiPresenceSettings = async (settings = {}) => {
    const { data } = await axios.post('/api/synthetic-cancel/api-presence/settings', settings);
    return data;
};
